import { Person, User } from '@core/types';

export function isPersonPopulated(val: Person | number): val is Person {
  return !!(val && typeof val === 'object' && 'id' in val);
}

export function isUserPopulated(val: User | number): val is User {
  return !!(val && typeof val === 'object' && 'fullname' in val);
}
